import React from 'react'
import CheckedIn from './CheckedInPanel'
import { BoardWrapper, ColumnsContainer } from './index.styled'
import Previous from './PreviousPanel'
import Upcoming from './UpcomingPanel'
import { useLobby } from './useLobby'
import { useLobbyPoll } from '../../../hooks/useLobbyPoll'

export default function LobbyScreen() {
  const { upcoming, checkedIn, previous }: any = useLobby()

  return (
    <BoardWrapper>
      <ColumnsContainer>
        <Upcoming data={upcoming} />

        <CheckedIn data={checkedIn} />

        <Previous data={previous} />
      </ColumnsContainer>
    </BoardWrapper>
  )
}
